import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { userLogout } from 'src/services/user/actionCreators';

interface ILogoutProps extends RouteComponentProps {
  logOut: () => void;
}

const Logout = ({ location, logOut }: ILogoutProps) => {
  const { from } = location.state || { from: { pathname: '/' } };

  logOut();

  return <Redirect to={from} />;
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>) => ({
  logOut: () => void dispatch(userLogout()),
});

export default connect(
  null,
  mapDispatchToProps
)(Logout);



// WEBPACK FOOTER //
// ./src/views/Logout.tsx